module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row contact-item list-item"
  }, [_c('div', {
    staticClass: "table-col table-col-80 overflow-hidden clickable",
    on: {
      "click": function($event) {
        return _vm.editBusiness()
      }
    }
  }, [_c('div', {
    staticClass: "business-name overflow-ellipsis",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.business.name || " - "))]), _c('div', {
    staticClass: "business-domain",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.business.domain || " - "))])]), _c('div', {
    staticClass: "table-col table-col-80 business-address-cell"
  }, [_c('div', {
    staticClass: "business-address overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.address || " - "))])]), _c('div', {
    staticClass: "table-col table-col-60"
  }, [_c('span', {
    staticClass: "btn-contact-status btn-contact-fake",
    class: 'contact-status-' + _vm.business.status
  }, [(_vm.business.human_status) ? _c('span', {
    class: _vm.statusIconClass
  }) : _vm._e(), _c('div', {
    staticClass: "contact-status"
  }, [_vm._v(_vm._s(_vm.business.human_status || " - "))])])]), _c('div', {
    staticClass: "table-col table-col-60"
  }, [_c('span', {
    class: _vm.stageClasses
  }, [_c('div', {
    staticClass: "contact-stage"
  }, [_vm._v(_vm._s(_vm.business.human_stage || " - "))])])]), _c('div', {
    staticClass: "table-col table-col-120"
  }, [(_vm.business.tags.length > 0) ? _c('div', {
    staticClass: "tags-list"
  }, [_c('tag', {
    style: ({
      color: '#' + _vm.tag_first.color
    }),
    attrs: {
      "tag": _vm.tag_first
    }
  }), (_vm.show_more_tags) ? _c('div', {
    staticClass: "tag",
    staticStyle: {
      "color": "rgb(41,69,86)",
      "border-right-color": "rgb(41,69,86)"
    }
  }, [_vm._v(_vm._s(_vm.tags_count_left) + "+")]) : _vm._e()], 1) : _c('span', [_vm._v("-")])]), _c('div', {
    staticClass: "table-col table-col-120 business-contacts-cell"
  }, [_c('div', {
    staticClass: "business-contacts overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.business.list_contacts || " - "))])]), _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu multi-level"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.editBusiness
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))]), _c('a', {
    on: {
      "click": _vm.destroyBusiness
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-80ea2482!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/businesses/list_item.vue
// module id = 1179
// module chunks = 1